import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MessageService } from 'primeng/api';
import { IDoctorCounter } from 'src/app/shared/interfaces/doctorCounter';
import { IDoctorException } from 'src/app/shared/interfaces/doctorException';
import { IDoctorTiming } from 'src/app/shared/interfaces/doctorTiming';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-doctor-calendar',
  templateUrl: './doctor-calendar.component.html',
  styleUrl: './doctor-calendar.component.css',
  providers: [MessageService]
})
export class DoctorCalendarComponent implements OnInit{

  drID: any = 7;
  drCalendarList: IDoctorTiming[];
  exceptionDays: IDoctorException[];
  exceptionModel: IDoctorException;
  visitType = EVisitType;
  drTimeCounter: IDoctorCounter = {
    bodyCounter: null,
    videoCounter: null,
    soundCounter: null
  };
  selectedData: any;

  hourList = [
    {title: '00', value: 0},
    {title: '01', value: 60},
    {title: '02', value: 120},
    {title: '03', value: 180},
    {title: '04', value: 240},
    {title: '05', value: 300},
    {title: '06', value: 360},
    {title: '07', value: 420},
    {title: '08', value: 480},
    {title: '09', value: 540},
    {title: '10', value: 600},
    {title: '11', value: 660},
    {title: '12', value: 720},
    {title: '13', value: 780},
    {title: '14', value: 840},
    {title: '15', value: 900},
    {title: '16', value: 960},
    {title: '17', value: 1020},
    {title: '18', value: 1080},
    {title: '19', value: 1140},
    {title: '20', value: 1200},
    {title: '21', value: 1260},
    {title: '22', value: 1320},
    {title: '23', value: 1380},
    {title: '24', value: 1440}
  ];




  constructor(private apiService: ApiService,
    private http: HttpClient,
    private messageService: MessageService
  ){}

  ngOnInit(): void {
    this.getCounter();
    this.getDrException();
    this.getDrCalendarList();
    
  }

  onDateSelected(date: string) {
    // console.log('Selected date:', date);
    this.selectedData = date;
  }


  getDrCalendarList() {
    // get default docotr time table
    this.http.get('../../../../../assets/json/drCalendarTable.json').subscribe((res: IDoctorTiming[]) => {
      
      this.drCalendarList = res;
    })

    this.apiService.apiCall('get', '/api/Doctor/GetAllDoctorActive').subscribe((res: any) => {
      console.log(res);

      
      // // Replace matching items in array1 with items from array2
      // const updatedArray = this.drCalendarList.map(item1 => {
      //   const matchingItem = res.body.model.find(item2 => item2.day == item1.day);
      //   return matchingItem ? matchingItem : item1;
      // });

      // const updatedArray = res.body.model.map(item1 => {
      //   for (const item2 of this.drCalendarList) {
      //     if (item1.day == item2.day) {
      //       return item2; // Replace item1 with the matching item2
      //     }
      //   }
      //   return item1; // Keep the original item1 if no match is found
      // });
      
      if (res.body.model != null || res.body.model.length != 0){

      const updatedList = this.drCalendarList.map(item1 => {
        const matchingItem = res.body.model.find(item2 => item2.day === item1.day);
      
        if (matchingItem) {
          return {
            ...item1,
            ...matchingItem,
            visitTypes: item1.visitTypes.map(v1 => {
              const matchingVisitType = matchingItem.visitTypes.find(v2 => v2.type === v1.type);
              return matchingVisitType ? matchingVisitType : v1;
            })
          };
        }
      
        return item1;
      });

      this.drCalendarList =updatedList;
      
      // console.log(updatedList);
    }

      // for(let i=0;this.drCalendarList.length;i++) {
      //   for(let j=0;res.body.model.length;j++) {
      //     if(this.drCalendarList[i].day == res.body.model[j].day) {
      //       this.drCalendarList[i] = res.body.model[j];
      //       break;
            
      //       // this.drCalendarList[i] = res.body.model[j];
      //     }
      //   }
      // }

      // this.drCalendarList.forEach(cal => {
      //   res.body.model.forEach(visit => {
      //     if(cal.id == visit.id) {
      //       this.drCalendarList
      //     }
      //   })
      // })
      
    })
  }

  changeVisitTime() {
    let updatedList = this.drCalendarList;

    // const updatedData = data.map(item => ({
    //   ...item,
    //   details: {
    //     ...item.details,
    //     value: Number(item.details.value),
    //   },
    // }));

    updatedList = updatedList
    .map(schedule => ({
      ...schedule,
      visitTypes: schedule.visitTypes
        .filter(visitType => visitType.isActive) // Keep only active visitTypes
        .map(detail => ({
          ...detail,
          start: Number(detail.start),
          end: Number(detail.end),
        })),
    }))
    .filter(schedule => schedule.visitTypes.length > 0); // Remove objects with empty visitTypes
    // console.log(updatedList);
    // console.log(JSON.stringify(updatedList));
    
    this.apiService.apiCall('post', '/api/Doctor/ChangeVisits', updatedList).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary:  'موفق', detail: 'تغییرات با موفقیت اعمال شد.' });
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail: res.body.message });
      }
      
    })
  }

  getCounter() {
    this.apiService.apiCall('get', '/api/Doctor/GetAllCounter').subscribe((res: any) => {
      // console.log(res);
      if (res.body.model != null || res.body.model.length != 0){
      this.drTimeCounter = res.body.model;
      }
    })
  }

  addCounter() {
    
    this.apiService.apiCall('post', '/api/Doctor/AddCounterTime', this.drTimeCounter).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary:  'موفق', detail: 'تغییرات با موفقیت اعمال شد.' });
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail: res.body.message });
      }
    })
  }

  getDrException() {
    this.apiService.apiCall('get', '/api/Doctor/GetAllException' ).subscribe((res: any) => {
      console.log(res);
      if (res.body.model != null || res.body.model.length != 0){
        this.exceptionDays = res.body.model;
      }
      
    })
  }

  deleteException(exp) {
    const temp = this.exceptionDays.filter(item => item.exception != exp);
    this.exceptionDays = temp;
    
  }

  addException() {

    // this.selectedData.gregorian = this.selectedData.gregorian.replace('-', '/');    


    if(this.selectedData){

      if (this.exceptionDays.find(x => x.exception.slice(0,10) == this.selectedData.gregorian)) {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: 'این تاریخ قبلا ثبت شده است.' });
        return false;
      } else {
        this.exceptionDays.push({exception: this.selectedData.gregorian+'T06:36:32'})
      }
      
    }

    const tt = [];

    this.exceptionDays.forEach(exp => {
      
      tt.push({exceptionTimeStamp: this.convertToTimestamp(exp.exception)}) 
    });
    console.log(tt);
    
    
    this.apiService.apiCall('post', '/api/Doctor/AddException', tt).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        // this.exceptionDays.push({exception: new Date(this.selectedData.gregorian) });
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'ثبت تاریخ استثنا با موفقیت انجام شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
    
    this.selectedData = null;
  }

  convertToTimestamp(datetime: string): number {
    return new Date(datetime).getTime()/1000;
  }
  

}
